import { render, staticRenderFns } from "./CardMainActions.vue?vue&type=template&id=70ad0a22&scoped=true"
import script from "./CardMainActions.js?vue&type=script&lang=js&external"
export * from "./CardMainActions.js?vue&type=script&lang=js&external"
import style0 from "./CardMainActions.vue?vue&type=style&index=0&id=70ad0a22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad0a22",
  null
  
)

export default component.exports